import { AnyAction } from 'redux';
import { CloudUtils } from '@portal/portal-core';
import * as RegionConstants from 'constants/region';

// getCurrentQueryParams is typed as {} upstream; query params are string-or-absent at this boundary
const params = CloudUtils.getCurrentQueryParams() as { region?: string };

export interface RegionState {
  selectedRegion: string | null;
}

const initialState: RegionState = {
  selectedRegion: params.region || null,
};

export default function Region(state: RegionState = initialState, action: AnyAction): RegionState {
  switch (action.type) {
    case RegionConstants.SELECTED_REGION:
      return {
        ...state,
        selectedRegion: action.selectedRegion,
      };
    default:
      return state;
  }
}
